module.exports = __webpack_public_path__ + "static/media/navidad8.392f9219.webp";